import React from 'react';
import { useParams, Navigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Header from '../components/header/HeaderOne';
import Footer from '../components/footer/FooterOne';
import Breadcrumb from '../components/sections/Breadcrumb';
import BlogDetailsSec from '../components/sections/BlogDetailsSec';
import blogPosts from '../components/data/blog-posts';

const BlogDetails = () => {
  const { t } = useTranslation();
  const { slug } = useParams();
  
  // Find the blog post by slug
  const post = blogPosts.find(p => p.slug === slug);
  
  // If no slug is provided (accessing /blog-details directly), use the first post
  const currentPost = slug ? post : blogPosts[0];
  
  // If slug is provided but post not found, redirect to blog page
  if (slug && !post) {
    return <Navigate to="/blog" replace />;
  }

  const blogTitle = currentPost ? t(currentPost.titleKey) : t('sections.breadcrumb.blog_details.title');

  return (
    <>
      <Header />
      <Breadcrumb 
        title={blogTitle}
        subtitle={blogTitle}
      />
      <BlogDetailsSec post={currentPost} />
      <Footer />
    </>
  );
};

export default BlogDetails;